import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetDispensingRequestUploadTypeWithDraftAppointmentDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useFetchDispensingRequestUploadTypeWithDraftAppointment = (appointmentId: string) => {
  const [getDispensingRequestUploadTypeWithDraftAppointment, { data }] = useLazyQuery(
    GetDispensingRequestUploadTypeWithDraftAppointmentDocument,
  );

  const appointment = getNode(data, 'Appointment');
  const pfDispensingRequestUploadType = appointment?.pfDispensingRequestUploadType;
  const existsDraftAppointment = !!appointment?.draftAppointment?.id;

  useEffect(() => {
    if (appointmentId) {
      getDispensingRequestUploadTypeWithDraftAppointment({ variables: { appointmentId } });
    }
  }, [appointmentId, getDispensingRequestUploadTypeWithDraftAppointment]);

  return { pfDispensingRequestUploadType, existsDraftAppointment };
};
